import { Box, Icon } from '@palmetto/palmetto-components';

// Read-only status banner surfaced at the top of the account Overview when the account has an
// active (non-resolved) change order. The label is derived in resolveChangeOrderBannerLabel.
const ChangeOrderBanner = ({ label, className }: { label: string; className?: string }) => {
  return (
    <Box
      borderWidth="xs"
      borderColor="info"
      radius="md"
      direction="row"
      alignItems="center"
      childGap="sm"
      fontSize="sm"
      padding="lg"
      margin="0 0 lg 0"
      background="primary"
      shadow="xs"
      className={className}
    >
      <Icon name="c-info" size="lg" color="info" />
      <Box fontWeight="bold">{label}</Box>
    </Box>
  );
};

export default ChangeOrderBanner;
